import React from "react";
export var EGenericStatusType;
(function (EGenericStatusType) {
    EGenericStatusType["SUCCESS"] = "SUCCESS";
    EGenericStatusType["WARNING"] = "WARNING";
    EGenericStatusType["DANGER"] = "DANGER";
    EGenericStatusType["PENDING"] = "PENDING";
})(EGenericStatusType || (EGenericStatusType = {}));
var GenericBackground = function (props) {
    var generateClassName = function () {
        switch (props.statusType) {
            case EGenericStatusType.SUCCESS:
                return "status-description success";
            case EGenericStatusType.DANGER:
                return "status-description danger";
            case EGenericStatusType.WARNING:
                return "status-description warning";
            case EGenericStatusType.PENDING:
                return "status-description pending";
            default:
                return "status-description pending";
        }
    };
    return (React.createElement("div", { className: "DMsanL_11_300 text-wrap fw-300 ".concat(generateClassName()) }, props.statusMessage));
};
export default GenericBackground;
